import React from 'react';
import { DataList } from 'commons-ui';
import { columnConfigs } from './listConfig';

interface IBlockUnblockDetails {
	getBlockUnblockDetails: () => any;
}

const BlockUnblockDetails = (props: IBlockUnblockDetails) => {
	const { getBlockUnblockDetails } = props;

	return <DataList fetchData={getBlockUnblockDetails} columnConfigs={columnConfigs} hideActions rowHeight={60} />;
};

export default BlockUnblockDetails;
